const proximalColor = getComputedStyle(document.documentElement).getPropertyValue('--text-section-proximal').trim();
const midColor = getComputedStyle(document.documentElement).getPropertyValue('--text-section-mid').trim();
const distalColor = getComputedStyle(document.documentElement).getPropertyValue('--text-section-distal').trim();
const LAPColor = getComputedStyle(document.documentElement).getPropertyValue('--background-lowAttenuation-plaque').trim();
const NCColor = getComputedStyle(document.documentElement).getPropertyValue('--background-nonCalcified-plaque').trim();
const CColor = getComputedStyle(document.documentElement).getPropertyValue('--background-calcified-plaque').trim();
const LumenColor = getComputedStyle(document.documentElement).getPropertyValue('--background-lumen').trim();

export type AppColors = {
  LUMEN: string;
  // fai color
  FAI1: string;
  FAI2: string;
  FAI3: string;
  FAI4: string;
  // plaque color
  CALCIUM: string;

  calcified: string;
  nonCalcified: string;
  lowAttenuation: string;

  // outline color
  lumenoutline: string;
  walloutline: string;

  // markerline color
  Proximal: string;
  Stenosis: string;
  Distal: string;
  MarkerArea: string;

  // component color
  aorta: string;
  la: string;
  lv: string;
  ra: string;
  rv: string;
  laWall: string;
  lvWall: string;
  raWall: string;
  rvWall: string;
  coronary: string;
  calcium: string;
  epicardial: string;
  avc: string;
  avcNode: string;

  territory: string[];
  myocardoal_coronary: string;
  autoLesion: string[];
  // thickness color
  paletteLAWT: string[];

  // content color
  isrcontent: string[];

  // FFR color
  paletteFFR: string[];
};


export const defaultColors: AppColors = {
  LUMEN: LumenColor,
  FAI1: '#f4ff95',
  FAI2: '#ffff00',
  FAI3: '#ff6600',
  FAI4: '#ff0000',
  CALCIUM: '#ffffff',

  calcified: '#f703d6',
  nonCalcified: '#00d0ff',
  lowAttenuation: '#ff6347',

  Proximal: proximalColor,
  Stenosis: midColor,
  Distal: distalColor,
  MarkerArea: '#4EFC19',

  lumenoutline: '#d4d438',
  walloutline: '#d87409',

  aorta: '#61bb46',
  la: '#F5821F',
  lv: '#E03A3E',
  ra: '#963D97',
  rv: '#009DDC',
  laWall: '#B86118',
  lvWall: '#A12A2D',
  raWall: '#5C255C',
  rvWall: '#005B88',
  coronary: '#fca6a6',
  calcium: '#FFFFFF',
  epicardial: '#E3E195',
  avc: '#A12A2D',
  avcNode: '#A12A2D',
  territory: ['#1B3251', '#708D49', '#DAA21F', '#FFFFFF', '#C53253'],
  myocardoal_coronary: '#c76e6e',
  // autoLesion: [ "#60a5fa","#f59e0b","#f97316","#ef4444"],
  autoLesion: ['#d4d438', '#d4d438', '#d4d438', '#d4d438'],
  paletteLAWT: [
    '#162036',
    '#14224B',
    '#183663',
    '#9ABE2D',
    '#D3A11E',
    '#FF981F',
    '#F6394C',
    '#F73673',
  ],

  isrcontent: ['#FF0000', '#00ff00', '#0000ff'],

  paletteFFR: [
    '#000001',
    '#660000',
    '#ff0000',
    '#ff8000',
    '#ffff00',
    '#ffffff',
  ],
};
